const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/use-syntheo",
    exact: true,
    component: "NewPage",
  },
];

export default routes;
